<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  watch: {
    '$route': {
      handler (to, from) {
        setTimeout(() => {
          if (window._czc) {
            window._czc.push(['_trackPageview', to.fullPath, ''])
          }
        }, 1000)
      },
      immediate: true
    }
  },
  mounted () {
    console.log('resfash')
    // this.$router.go(0)
  }
}
</script>

<style lang="less">
  * {
    margin: 0;
    padding: 0;
  }
  ul,ol {
    list-style: none;
  }
  html, body {
    height: 100%;
    -webkit-text-size-adjust: 100% !important;
  }
  #app {
    height: 100%;
  }
  img {
    border: none;
    vertical-align: middle;
  }
  input, textarea {
    outline: none;
    border: none;
  }
  .mint-toast {
    .mint-toast-text {
      padding: 10px!important;
      font-size: 32px!important;
    }
  }
</style>
